import React from "react";
import styled from "styled-components";
import colors from "../../constatns/colors";
import useWindowDimensions from "../../constatns/size";
import { HiMinus, HiPlus } from "react-icons/hi";

import "../../styles/home.css";

function FaqsCard({title, description, titleStyle, isDescription, onClick}) {
    const { width, height } = useWindowDimensions();
    
  return (
        <Container width={width} height={height} id="about">
            <InnerContainer width={width} height={height}>
                <Title style={{ color: isDescription ? colors.btnPrimary : colors.white , ...titleStyle}}>{title}</Title>
                <Handler onClick={onClick}>
                    { isDescription ? <HiMinus size={25} /> : <HiPlus size={25} /> }
                </Handler>
            </InnerContainer>
            {isDescription &&  <Description>{description}</Description>}

                
        </Container>
  );
}

const Container = styled.div`
    background-color: ${colors.darkBlue};
    margin-top: 30px;
    border-radius: 10px;
    padding: 30px;
    @media (max-width: 420px) {
        padding: 10px;
    }
`

const InnerContainer = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${colors.white};
`

const Handler = styled.button`
    display: flex;
    border-width: 0px;
    background-color: #303665;
    color: ${colors.white};
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
`

const Title = styled.h3`
    color: white;
    font-weight: 500;
    margin: 0px;
    width: 80%;
`

const Description = styled.p`
    color: ${colors.grey};
    font-size: 12px;
    margin: 0px;
    width: 80%;
`
export default FaqsCard;
